import api from '@/api'

const state = {
  totalOrders: {},
  logisticOrders: {},
  expenses: {},
  paymentReports: []
}
const actions = {
  getTotalOrders({ commit }, {params}) {
    return new Promise((resolve, reject) => {
      api.summary.totalOrders(params).then(
        response => {
          commit('setTotalOrders', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getLogisticOrders({ commit }, {params}) {
    return new Promise((resolve, reject) => {
      api.summary.logisticOrders(params).then(
        response => {
          commit('setLogisticOrders', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getExpenses({ commit }, {params}) {
    return new Promise((resolve, reject) => {
      api.summary.expenses(params).then(
        response => {
          commit('setExpenses', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getPaymentReports({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.summary.paymentReports(params).then(
        response => {
          commit('setPaymentReports', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  paymentReportsDownload({ _ }, { params }) {
    return new Promise((resolve, reject) => {
      api.summary.paymentReportsDownload(params).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  }
}
const mutations = {
  setTotalOrders(state, value) {
    state.totalOrders = value
  },
  setLogisticOrders(state, value) {
    state.logisticOrders = value
  },
  setExpenses(state, value) {
    state.expenses = value
  },
  setPaymentReports(state, value) {
    state.paymentReports = value
  }
}
const getters = {
  totalOrders: state => state.totalOrders,
  logisticOrders: state => state.logisticOrders,
  expenses: state => state.expenses,
  paymentReports: state => state.paymentReports
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
